module.exports = __webpack_public_path__ + "img/red-logo.1b520fe0.png";